import { LabeledValue, ModalOpenButton } from "@msys/ui";
import { Delete as DeleteIcon } from "@mui/icons-material";
import { Edit as EditIcon } from "@mui/icons-material";
import {
  Button,
  ButtonProps,
  IconButton,
  IconButtonProps,
  Stack,
} from "@mui/material";
import { useTranslate } from "@tolgee/react";
import { ProductTypesSearchModal } from "../modals/ProductTypesSearchModal.js";

interface ProductType {
  id: string;
  key: string;
  label: string;
  productTypeSystemKey: "ETIM6" | "ETIM7" | "ETIM8" | "ETIM9" | "ETIM10";
}

interface Props {
  label?: string;
  valueLabel?: string;
  productType?: ProductType | null;
  handleChange: (productType: ProductType | null) => void;
  canEdit?: boolean;
  buttonProps?: ButtonProps;
  iconButtonProps?: IconButtonProps;
}
export function PickProductTypeButton({
  label,
  valueLabel,
  productType,
  handleChange,
  canEdit = true,
  buttonProps,
  iconButtonProps,
}: Props) {
  const { t } = useTranslate("ProductOverview");

  if (!canEdit && !productType) return null;

  if (productType) {
    return (
      <Stack
        direction="row"
        sx={{
          width: "100%",
          justifyContent: "space-between",
          alignItems: "center",
        }}
      >
        <LabeledValue label={valueLabel ?? t("Product type")}>
          {productType.label}
        </LabeledValue>
        {canEdit && (
          <ModalOpenButton
            Modal={ProductTypesSearchModal}
            modalProps={{
              handleSelectProductType: async (productType, handleClose) => {
                handleChange(productType);
                handleClose();
              },
            }}
          >
            <IconButton size="small" color="secondary" {...iconButtonProps}>
              <EditIcon />
            </IconButton>
          </ModalOpenButton>
        )}
        {canEdit && (
          <IconButton
            size="small"
            color="secondary"
            {...iconButtonProps}
            onClick={() => handleChange(null)}
          >
            <DeleteIcon />
          </IconButton>
        )}
      </Stack>
    );
  }

  return (
    <Stack
      direction="row"
      sx={{
        justifyContent: "flex-start",
      }}
    >
      <LabeledValue label={valueLabel ?? t("Product type")}>
        <ModalOpenButton
          Modal={ProductTypesSearchModal}
          modalProps={{
            handleSelectProductType: async (productType, handleClose) => {
              handleChange(productType);
              handleClose();
            },
          }}
        >
          <Button
            size="small"
            variant="text"
            color="secondary"
            {...buttonProps}
          >
            {label ?? t("Assign product type")}
          </Button>
        </ModalOpenButton>
      </LabeledValue>
    </Stack>
  );
}
